import React from 'react';
// import {Container,Row,Image} from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Fade from 'react-reveal/Fade';
import './About.css';

function About() {
    return (
        <div className='about my-5' id='about'>
            <Container >
                <h2 className='about__header my-4'>About Us</h2>
                <Row>
                    
                    <Col sm={12} lg={6} className="ml-2 my-2"  >
                        <Fade left>
                            <Image src="/images/placeholder_2.jpg" fluid/>
                        </Fade>
                    </Col>

                    <Col  className="mx-2 my-2"  >
                        <Fade right>
                            <h6 className='about__text my-2'> Royal Smiles Dental Clinic GreenSpan </h6>
                            <p className='text'> Royal Smiles Clinic is a modern dental clinic, specialised in advanced diagnostics and treatment of dental disorders. We guarantee comprehensive diagnostics and offer various forms of dental care, surgical procedures, and cosmetic dental services. </p>
                            <p className='text'>Even better ,We have a team of qualified dentists with a wide range of specialization in different areas of dentistry & several years of experience.</p>
                            <p className='text'>We accept most of the modern payment methods , we also accept most Insurance cards so your payment is seemless.</p>
                        </Fade>
                    </Col>
                </Row>
            </Container>
            
        </div>
    );
}

export default About;
